export default "__VITE_ASSET__CjYB5dRL__"